<form
  class="p-grid mu-flex-dir-column mu-position-relative mu-form-content"
  [formGroup]="loginForm"
  (submit)="eventSubmit.emit()"
  appValidator
>
  <div class="p-grid container-form">
    <app-mu-form-fieldset [customGridColMd]="12" [customGridCol]="12" [customGridColLg]="12" [slimPadding]="true" [label]="'email'">
      <input pInputText id="email" type="text" name="email" formControlName="email" [placeholder]="'form.placeholder.email' | translate" />
    </app-mu-form-fieldset>
    <app-mu-form-fieldset
      [customGridColMd]="12"
      [customGridCol]="12"
      [customGridColLg]="12"
      [slimPadding]="true"
      [label]="'password'"
      [withIcon]="true"
    >
      <i class="fas fa-eye" aria-hidden="true" (click)="eventShowPassword.emit($event)"></i>
      <input
        pInputText
        id="password"
        type="password"
        name="password"
        formControlName="password"
        [placeholder]="'form.placeholder.password' | translate"
        (keydown.enter)="eventSubmit.emit()"
      />
    </app-mu-form-fieldset>
    <app-mu-form-fieldset class="flex" [customGridColMd]="8" [customGridCol]="6" [customGridColLg]="6" [slimPadding]="true">
      <p-checkbox
        id="login-remember"
        name="remember"
        formControlName="remember"
        [(ngModel)]="isChecked"
        [binary]="true"
        (click)="eventRemember.emit()"
      ></p-checkbox>
      <label for="remember">{{ 'form.label.rememberLoginData' | translate }}</label>
    </app-mu-form-fieldset>
    <app-mu-form-fieldset
      class="mu-text-align-right"
      [customGridColMd]="4"
      [customGridCol]="6"
      [customGridColLg]="6"
      [iconFeedback]="false"
      [slimPadding]="false"
    >
      <a [routerLink]="['/page/recover']">{{ 'page.login.recover.1' | translate }}</a>
    </app-mu-form-fieldset>
    <div class="error"></div>
  </div>

  <p-button
    type="submit"
    class="mu-button mu-without-padding mu-auth-button"
    [label]="'page.login.tabs.login' | translate"
    [disabled]="!loginForm?.get('email')?.value || !loginForm?.get('password')?.value || loginForm?.get('isInvalidForm')?.value"
  >
    <app-loading [showLoading]="flagList?.get(flagListEnum.LOADING)" type="icon"></app-loading>
  </p-button>
</form>
